<ion-app [ngClass]="'theme-'+userService.theme">
    <app-menu></app-menu>
    <ion-router-outlet id="main-content" [animated]="true"></ion-router-outlet>
</ion-app>
